import React, { useState, useEffect } from "react";
import {
  Box, Typography, Grid, Card, CardContent, CircularProgress,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useGetAmStatsMutation } from "state/api";
import { toast } from "react-toastify";
import foliregLogo  from "../../assets/Folireg.png";
import bisberryLogo from "../../assets/Bisberry.png";
import endocareLogo from "../../assets/Endocare.png";
import lycoredLogo  from "../../assets/Lycored-M.png";

const StatCard = ({ title, value, color = "primary.main", logo }) => (
  <Card sx={{ height: "100%" }}>
    <CardContent>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.5 }}>
        {logo && (
          <Box component="img" src={logo} alt=""
            sx={{ height: 16, width: "auto", objectFit: "contain", flexShrink: 0 }} />
        )}
        <Typography variant="body2" color="text.secondary">{title}</Typography>
      </Box>
      <Typography variant="h4" fontWeight={700} color={color}>{value}</Typography>
    </CardContent>
  </Card>
);

const AmDashboard = () => {
  const { user } = useSelector((s) => s.auth);
  const [getAmStats] = useGetAmStatsMutation();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user?.role) {
      setLoading(true);
      getAmStats({ MgCd: user.role })
        .unwrap()
        .then(setStats)
        .catch((err) => toast.error(err?.data?.message || "Failed to load stats"))
        .finally(() => setLoading(false));
    }
  }, [user, getAmStats]);

  if (loading) return <Box sx={{ display: "flex", justifyContent: "center", py: 5 }}><CircularProgress /></Box>;

  const t = stats?.totals || {};

  return (
    <Box>
      <Typography variant="h5" fontWeight={700} gutterBottom>AM Dashboard</Typography>

      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={6} sm={4} md={3}><StatCard title="Team Size"      value={t.team_size             || 0} /></Grid>
        <Grid item xs={6} sm={4} md={3}><StatCard title="Rx Visits"      value={t.total_rx_visits       || 0} color="success.main"   logo={foliregLogo} /></Grid>
        <Grid item xs={6} sm={4} md={3}><StatCard title="New Rx"         value={t.total_new_rx          || 0} color="info.main"      logo={foliregLogo} /></Grid>
        <Grid item xs={6} sm={4} md={3}><StatCard title="Samples Given"  value={t.total_samples         || 0}                        logo={foliregLogo} /></Grid>
        <Grid item xs={6} sm={4} md={3}><StatCard title="POB Strips"     value={t.total_pob             || 0} color="warning.main"   logo={foliregLogo} /></Grid>
        <Grid item xs={6} sm={4} md={3}><StatCard title="Weekly Entries" value={t.total_weekly          || 0}                        logo={bisberryLogo} /></Grid>
        <Grid item xs={6} sm={4} md={3}><StatCard title="PSP Kits"       value={t.total_psp_kits        || 0} color="secondary.main" logo={endocareLogo} /></Grid>
        <Grid item xs={6} sm={4} md={3}><StatCard title="Lycored Visits" value={t.total_lycored_visits  || 0}                        logo={lycoredLogo} /></Grid>
      </Grid>

      <Typography variant="h6" fontWeight={600} gutterBottom>Leaderboard (by New Rx)</Typography>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>EmpNo</TableCell>
              <TableCell>New Rx</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(stats?.leaderboard || []).map((mr, i) => (
              <TableRow key={mr.EmpNo}>
                <TableCell>{i + 1}</TableCell>
                <TableCell>{mr.name}</TableCell>
                <TableCell>{mr.EmpNo}</TableCell>
                <TableCell fontWeight={700}>{mr.total_new_rx}</TableCell>
              </TableRow>
            ))}
            {(!stats?.leaderboard || stats.leaderboard.length === 0) && (
              <TableRow><TableCell colSpan={4} align="center">No data yet</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default AmDashboard;
